// extracted by mini-css-extract-plugin
export default {"outerContainer":"AlertsMainPage_outerContainer__3B9Co","body":"AlertsMainPage_body__si7dw"};